/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Role_Bound_TenantInputs */

const cs_clients_role_bound_tenant = /** @type {(inputs: Clients_Role_Bound_TenantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poptávky: kritéria pronájmu, rozpočet, dispozice, lokalita, stav financování u každé poptávky.`)
};

const en_clients_role_bound_tenant = /** @type {(inputs: Clients_Role_Bound_TenantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demands: rent criteria, budget, layout, locality, financing status on each demand.`)
};

/**
* | output |
* | --- |
* | "Demands: rent criteria, budget, layout, locality, financing status on each demand." |
*
* @param {Clients_Role_Bound_TenantInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_role_bound_tenant = /** @type {((inputs?: Clients_Role_Bound_TenantInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Role_Bound_TenantInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_role_bound_tenant(inputs)
	return cs_clients_role_bound_tenant(inputs)
});